import React from 'react';
import classnames from 'classnames';

const componentClass = 'accountSection';

const AccountsTabSection = ({ contentClassNames, headerClassNames, title, text, children }) => {
    const contentClasses = classnames(`${componentClass}__content`, contentClassNames);
    const headerClasses = classnames(`${componentClass}__header`, headerClassNames);

    return <div className={componentClass}>
        <div className={headerClasses}>
            <span>{ title }</span>
            <p>{ text }</p>
        </div>
        <div className={contentClasses}>
            { children }
        </div>
    </div>;
};

export default AccountsTabSection;
